






























import { defineComponent } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
// import { DEVKEY } from '@/common/constants/cms'
// import ContentTargeter from '~/components/global/targeters/ContentTargeter.vue'

export default defineComponent({
  // components: {
  // ContentTargeter,
  // },
  props: {
    trademarks: {
      type: Array,
      default: () => [],
    },
    legals: {
      type: Array,
      default: () => [],
    },
    legalStatement: {
      type: String,
      default: undefined,
    },
  },
  setup() {
    return { isEmpty }
  },
})
